// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LSex","content":"styles_content__31GX5","tableWrap":"styles_tableWrap__2nSE2"};